module.exports = __webpack_public_path__ + "static/media/dealtNoTrumps_1.9ca3e843.png";